<template>
  <div class="landingPage wrapper">
    <ciaHeader />
    <div class="page">
      <div class="page__inner cia-container txt">
        <h1>ERROR 404</h1>
        <h2>Strona której szukasz nie istnieje.</h2>
        <div class="page__buttons">
          <ciaButton
            :title="'Strona główna'"
            :click="goToHome"
          >Strona główna</ciaButton>
          <ciaButton
            v-if="token"
            :title="'Dashboard'"
            :click="goToDashboard"
          >Dashboard</ciaButton>
        </div>
      </div>
    </div>
    <ciaFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ciaHeader from './../components/LandingPage/ciaHeader.vue';
import ciaFooter from './../components/LandingPage/Footer.vue';
import ciaButton from './../components/LandingPage/button.vue';

export default {
  name: 'page-not-found',
  components: {
    ciaHeader,
    ciaFooter,
    ciaButton,
  },
  computed: {
    ...mapGetters('app', [
      'token',
    ]),
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    goToDashboard() {
      this.$router.push('/dashboard');
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700&subset=latin-ext');
  @import "./../scss/landingpage.scss";
</style>
